module.exports = __webpack_public_path__ + "static/media/ekspozytory_02_B.c060b297.png";